<template>
    <el-dialog class="el-dialogs" :title="title" :append-to-body="true" width="620px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-transfer
                v-if="this.selectListName != 'department'"
                class="transferSelect"
                v-model="selectList"
                :titles="['未选择','已选择']"
                :props="fieldAlias"
                :data="dataList">
        </el-transfer>
        <div v-else class="flex_b_c">
            <div class="treeData">
                <el-tree
                        ref="tree"
                        :data="dataList"
                        show-checkbox
                        node-key="id"
                        default-expand-all
                        :props="defaultProps">
                </el-tree>
            </div>
            <div>
                <el-button :disabled="dataListSelect.length ? false : true" type="primary" icon="el-icon-arrow-left" @click="selectCancel()"></el-button>
                <el-button type="primary" icon="el-icon-arrow-right" @click="selectData()"></el-button>
            </div>
            <div class="selectTabe">
                <el-table
                        :data="selectList"
                        size="small"
                        height="100%"
                        class="table" border
                        ref="multipleTable"
                        :row-key="'id'"
                        @selection-change="selectionChangeHandle"
                >
                    <el-table-column type="selection" width="50"/>
                    <el-table-column prop="departmentName" label="已选择" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addScope",
    data() {
        return {
            title: '新增',
            visible: false,
            fieldAlias: {
                key: 'id',
                label: 'name'
            },
            dataList: [], //所有数据
            selectList: [], //已经选中的数据
            selectListName: '', //选中数据存贮的名字

            defaultProps: {
                children: 'children',
                label: 'departmentName'
            },
            dataListSelect: [],//表格勾选数据
        }
    },

    methods: {
        //allList所有数据 selectList已经选中的数据 selectListName选中数据存贮的名字(department用户组)
        init(allList, selectList, selectListName) {
            this.visible = true
            this.dataList = allList
            this.selectListName = selectListName
            if (this.selectListName != 'department'){
                this.selectList = selectList.map(item => {
                    return item.id
                })
            }else {
                this.selectList = selectList
                this.$nextTick(()=>{
                    this.selectList.forEach(item=>{
                        this.$refs.tree.setChecked(item,true)
                    })
                })
            }
        },

        //选中数据
        selectData() {
            this.selectList = []
            let selectData = this.$refs.tree.getCheckedNodes()
            selectData.forEach(item=>{
                if (!item.children || item.children.length == 0){
                    this.selectList.push(item)
                }
            })
        },

        //取消选中
        selectCancel(){
            this.dataListSelect.forEach(item=>{
                this.selectList = this.selectList.filter(item2=>{
                    return item2.id != item.id
                })
                this.$refs.tree.setChecked(item,false)
            })
            this.$refs.multipleTable.clearSelection()
            this.dataListSelect = []
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        doSubmit() {
            let selectData = []
            if (this.selectListName != 'department'){
                this.dataList.forEach(item => {
                    this.selectList.forEach(item2 => {
                        if (item.id == item2) {
                            selectData.push(item)
                        }
                    })
                })
            }else {
                selectData = this.selectList
            }
            this.$emit('selectedData', {
                selectListName: this.selectListName,
                selectData,
            })
            this.visible = false
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.treeData {
    width: 220px;
    height: 300px;
    overflow: auto;
    border: 1px solid #DCDCDC;
    border-radius: 4px;
}

.selectTabe {
    width: 220px;
    height: 300px;
}
</style>